import { Box, Button, styled } from "@mui/material"

export const ProvidersMain = styled(Box)({
  height: "80vh",
  display: "flex",
})
export const ProvidersMainLeft = styled(Box)({
  // flex: 1,
  // width: "fit-content",
  width: "20%",
  display: "flex",
  flexDirection: "column",
})
export const ProvidersMainLeftHeader = styled(Box)({
  backgroundColor: "#3C77EF",
  height: "8vh",
  borderRight: "1px solid #FFFFFF",
  display: "flex",
  alignItems: "center",
  paddingLeft: "30px",
  // alignItems
})
export const ProvidersMainLeftBody = styled(Box)({
  backgroundColor: "#FFFFFF",
  // flex: 1,
  height: "72vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "6px 0px 10px #00000029",
  zIndex: 2,
  // borderRight: "1px solid #000000"
})
export const ProvidersMainLeftBodyHeader = styled(Box)({
  height: "48px",
  backgroundColor: "#F8F9FA",
})
export const ProvidersMainLeftBodyMain = styled(Box)({
  // position: "relative",
  borderBottom: "2px solid #E4E4E4",
  flex: 1,
  overflowY: "scroll",
})

export const ProvidersMainLeftBodyFooter = styled(Box)({
  // border: "1px solid red",
  // position: "absolute",
  // bottom: 0,
  display: "flex",
  justifyContent: "center",
  width: "100%",
  padding: "10px 20px",
})

export const ProvidersMainRight = styled(Box)({
  // flex: 4,
  width: "80%",
  display: "flex",
  flexDirection: "column",
})
export const ProvidersMainRightHeader = styled(Box)({
  backgroundColor: "#3C77EF",
  height: "8vh",
})
export const ProvidersMainRightTable = styled(Box)({
  backgroundColor: "#FFFFFF",
  flex: 1,
  // padding: "0 10px"
})
